<template>
  <BModal
    v-model="isVisible"
    modal-class="zoomIn"
    hide-footer
    no-close-on-backdrop
    centered
    title="Confirmation de suppression"
    @hidden="onClose"
  >
    <div class="mt-2 text-center">
      <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
        <h4>Êtes-vous sûr ?</h4>
        <p class="text-muted mx-4 mb-0">
          Voulez-vous vraiment supprimer cette enquête ? Cette action est
          irréversible.
        </p>
      </div>
    </div>
    <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
      <BButton variant="light" @click="handleCancel" :disabled="deleting"
        >Annuler</BButton
      >
      <BButton variant="danger" @click="handleConfirm" :disabled="deleting">
        <span
          v-if="deleting"
          class="spinner-border spinner-border-sm me-1"
        ></span>
        {{ deleting ? 'Suppression...' : 'Oui, Supprimer' }}
      </BButton>
    </div>
  </BModal>
</template>

<script>
import surveyService from '@/shared/services/survey.service';
import notificationService from '@/shared/services/notification.service';

export default {
  name: 'DeleteSurveyModal',
  props: {
    modelValue: { type: Boolean, default: false },
    submission: { type: Object, default: null },
  },
  emits: ['update:modelValue', 'deleted'],
  data() {
    return { deleting: false };
  },
  computed: {
    isVisible: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit('update:modelValue', v);
      },
    },
  },
  methods: {
    handleCancel() {
      this.isVisible = false;
    },
    onClose() {
      this.$emit('update:modelValue', false);
    },
    async handleConfirm() {
      if (!this.submission?.id) return;
      this.deleting = true;
      try {
        await surveyService.deleteSurveySubmission(this.submission.id);
        this.isVisible = false;
        notificationService.successAction('delete', 'survey');
        this.$emit('deleted', this.submission.id);
      } catch (err) {
        console.error(err);
        notificationService.errorAction(
          'delete',
          'survey',
          err.response?.data?.message || 'Erreur lors de la suppression.',
        );
      } finally {
        this.deleting = false;
      }
    },
  },
};
</script>
